import type { JSONContent } from '@tiptap/core';
import { DRAGGABLE_ITEM_NODE_NAME } from '../../../editor/extensions/draggable-item';

export function wrapInDraggableItem(node: JSONContent): JSONContent {
  return {
    type: DRAGGABLE_ITEM_NODE_NAME,
    content: [node],
  };
}

export function unwrapDraggableItems(nodes: JSONContent[]): JSONContent[] {
  return nodes.flatMap((node) => {
    if (node.type === DRAGGABLE_ITEM_NODE_NAME && node.content) {
      return node.content;
    }
    return [node];
  });
}
